import { Skeleton } from "@/components/ui/skeleton";

export default function JobCategoriesSkeleton() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" role="status" aria-label="Loading job categories">
      {Array.from({ length: 6 }, (_, index) => (
        <div key={index} className="recent-job-card min-h-[224px] animate-pulse p-5">
          <div className="flex items-start gap-3">
            <Skeleton className="h-10 w-10 rounded-lg" />
            <Skeleton className="mt-2 h-4 w-32" />
          </div>
          <Skeleton className="mt-5 h-3 w-20" />
          <div className="mt-5 space-y-3 border-t border-border pt-4">
            <Skeleton className="h-3 w-full" />
            <Skeleton className="h-3 w-4/5" />
            <Skeleton className="h-3 w-3/5" />
          </div>
        </div>
      ))}
    </div>
  );
}
